import { makeStyles } from '@material-ui/core';
import LogoIcon from './LogoIcon';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontSize: 18,
    fontWeight: 400,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  strong: {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
}));

const LogoFull = () => {
  const classes = useStyles();

  return (
    <span className={classes.root}>
      <LogoIcon />
      <span>
        <b className={classes.strong}>Data Platform</b> Portal
      </span>
    </span>
  );
};

export default LogoFull;
